var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOther = function SvgOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#other_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.748 17.25H14.227a2.334 2.334 0 0 0-2.393 1.928L8.5 42.37a2.262 2.262 0 0 0 2.395 2.38H41.08a2.257 2.257 0 0 0 2.393-2.38L40.14 19.178a2.33 2.33 0 0 0-2.392-1.928"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M22.072 34.169s1.801 3.167 4.563 2.802C32.04 35.996 31.2 28.687 33 25.885c-4.564-1.827-8.767-.487-10.928.975-2.762 1.827-2.762 4.629 0 7.309"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M26 30s-2.857.667-5 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.103 12.345A6.275 6.275 0 0 0 25.96 7.25a6.27 6.27 0 0 0-6.127 5.063"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "other_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h52v52H0z"
  })))));
};
export default SvgOther;